import { render, staticRenderFns } from "./ReassignDialog.vue?vue&type=template&id=0fc6b2b0&"
import script from "./ReassignDialog.vue?vue&type=script&lang=js&"
export * from "./ReassignDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports